import db, { parseFirestoreDoc } from '@helpers/firebase/Firestore';
import functionsApi from '@helpers/firebase/Functions';
import { functions } from '@helpers/firebase/Initialize';
import { Request, RequestCall, RequestOp, RequestReturn, RequestStatus } from '@types';

export const parseRequestDoc = (doc: db.DocumentSnapshot) => {
  return parseFirestoreDoc<Request>(doc, 'requestId');
};

export const handleRequest = functionsApi.httpsCallable<RequestCall, RequestReturn>(
  functions,
  'requests-handleRequest'
);

export const addRequest = async (request: Omit<RequestCall, 'op'>) => {
  const result = await handleRequest({ ...request, op: RequestOp.ADD });
  return result.data as RequestStatus;
};

export const acceptRequest = async (request: Omit<RequestCall, 'op'>) => {
  await handleRequest({ ...request, op: RequestOp.ACCEPT });
};

export const rejectRequest = async (request: Omit<RequestCall, 'op'>) => {
  await handleRequest({ ...request, op: RequestOp.REJECT });
};

export const deleteRequest = async (request: Omit<RequestCall, 'op'>) => {
  await handleRequest({ ...request, op: RequestOp.DELETE });
};

export function chooseByStatus<T>(status: RequestStatus, choices: Record<RequestStatus, T>) {
  if (status in choices) return choices[status];
}
